/**
 * ReviewListContainer
 * --
 */
import React from 'react';
import ReviewList from 'routes/admin.routes/admin.review/ReviewList';
import { useUserStack } from 'store';

const ReviewListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ReviewList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default ReviewListContainer;
